import * as React from 'react';
import s from './common.module.scss';
import classNames from 'classnames';
import { CustomModalLayout, Loader as WsrLoader } from 'wix-style-react';
export var Loader = function () { return (React.createElement("div", { "data-hook": "initialization-loader", className: s.initializationLoader },
    React.createElement(WsrLoader, null))); };
export var CustomModalLoader = function () { return (React.createElement(CustomModalLayout, { maxHeight: "675px", width: "570px" },
    React.createElement("div", { "data-hook": "initialization-loader", className: classNames(s.initializationLoader, s.custom) },
        React.createElement(WsrLoader, null)))); };
//# sourceMappingURL=Loader.js.map